import React from "react";
import { Rating } from "./";
import * as Request from "superagent";
import {GoogleReview} from './../../models';

interface Props {
  reviews: GoogleReview[];
}
interface State {
}

class ReviewsList extends React.Component<Props, State> {
  constructor(props) {
    super(props);
  }

  render() {
    const { reviews } = this.props;
    return (
      reviews.length > 0 ? <div className={`reviews-list`}>
      {reviews.length > 0 &&
        reviews.map(review => {
          const {rating} = review;
          return (
            <div key={review.time} className="review-item">
              <strong className="review-author">{review.author_name}</strong>
              <div className="rating-container">
                <Rating isLarge={false} ratingValue={rating} />{" "}
                <span className="rating-time">
                  {review.relative_time_description}
                </span>
              </div>
              <div className="review-text">{review.text}</div>
            </div>
          );
        })
      }
    </div> : <p>Reviews are not available.</p>
    );
  }
}

export default ReviewsList;
